module.exports = __webpack_public_path__ + "01_long_grey.02a25e0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_long_grey.png
// module id = d6xf
// module chunks = 0